<template>
    <div class="homeGlobeToolBar">
        <div title="测量" class="globeToolButton">
            <img
                    class="img_box" :src="imgMeasure" v-on:click="showMeasure"
                    v-on:mouseenter="imgMeasure = 'globeToolbar/测量(hover).png'"
                    v-on:mouseleave="imgMeasure = 'globeToolbar/测量.png'"
            />
            <div class="measureBar" v-if="isMeasureBarShow">
                <div title="测面积" class="measureIn globeToolButton" v-show="!$store.state.isMeasuring">
                    <img class="img_box" :src="imgArea" v-on:click="measureArea" />
                </div>
                <div title="测距离" class="measureIn globeToolButton" v-show="!$store.state.isMeasuring">
                    <img class="img_box" :src="imgDistance" v-on:click="measureDis" />
                </div>
                <div title="清空测量" class="measureIn globeToolButton" v-show="$store.state.isMeasuring">
                    <img class="img_box" :src="imgClear" v-on:click="measureClear" />
                </div>
            </div>
        </div>
        <div title="主视角" style="margin-top:0.15rem;" class="globeToolButton">
            <img class="img_box" :src="imgHome" v-on:click="home" />
        </div>
        <div
                title="路网开关" class="globeToolButton"
                v-on:mouseenter="imgRoad = roadOn? 'globeToolbar/路网开关(开_hover).png': 'globeToolbar/路网开关(关_hover).png'"
                v-on:mouseleave="imgRoad = roadOn? 'globeToolbar/路网开关(开_默认).png': 'globeToolbar/路网开关(关_默认).png'"
        >
            <img class="img_box" :src="imgRoad" v-on:click="showRoad" />
        </div>
        <div title="选择底图" class="globeToolButton">
            <div>
                <img class="img_box" :src="imgDitu" v-on:click="isSelectorShow = !isSelectorShow" />
            </div>
            <div class="flex-div-layes" v-if="isSelectorShow">
                <label
                        class="selectCompare-rolling-radioItem radio-box"
                        v-for="(item, index) in radios" :key="item.id" @click="check(index, item.value)"
                >
                    <input
                            :id="index" v-model="layerRadio"
                            :name="item.label" :value="item.label" :checked="item.isChecked"
                            type="radio" class="selectCompare-rolling-radioInput" hidden
                    />
                    <label :for="index" class="selectCompare-rolling-radioLabel">{{ item.label }}</label>
                </label>
            </div>
        </div>
        <div class="globeZoomButton">
            <div title="zoom in" class="globeToolButton-button">
                <img class="img_box" :src="imgZoomOut" v-on:click="clickZoom('add')" />
            </div>
            <div class="globeZoomButton-circle">
                <div ref="compass" title="指北针" class="globeZoomButton-circle-outer" :style="{ transform: compassAngleStyle }" @mousedown="compassMouseDown()">
                    <div class="triangle"></div>
                    <div style="left:-0.3rem;" class="horizontalLine"></div>
                    <div style="right:-0.3rem;" class="horizontalLine"></div>
                    <div class="verticalLine"></div>
                </div>
                <!--中心-->
                <div class="globeZoomButton-circle-inter" v-on:click="North()">
                    <div @mouseenter="isNorthShow = true" v-show="!isNorthShow">
                        <p class="globeZoomButton-circle-inter-zoom">Zoom</p>
                        <p class="globeZoomButton-circle-inter-value" id="mainArea-globe-zoomInfo-level">{{$store.state.level}}</p>
                    </div>
                    <div @mouseleave="isNorthShow = false" v-show="isNorthShow">
                        <img style="height:2.4rem;width:1.3rem" :src="imgNorth"/>
                    </div>
                </div>
            </div>
            <div title="zoom out" style="position:relative;top:0.2rem;" class="globeToolButton-button">
                <img class="img_box" :src="imgZoomIn" v-on:click="clickZoom('subtract')"/>
            </div>
        </div>
        <div title="截图" class="img_div_style" v-on:click="captureGlobe()">
            <img
                    src="globeToolbar/截图grey.png" class="img_style"
                    @mouseenter="src='globeToolbar/截图hover.png'" @mouseleave="src='globeToolbar/截图grey.png'"
            >
        </div>
    </div>
</template>

<script>
    import saveAs from 'file-saver';
    export default {
        name: "HomeGlobeToolBar",
        data() {
            return {
                imgDitu: "globeToolbar/选择底图.png",
                imgRoad: "globeToolbar/路网开关(开_默认).png",
                imgMeasure: "globeToolbar/测量.png",
                imgArea: "globeToolbar/测面积.png",
                imgDistance: "globeToolbar/测距离.png",
                imgHome: "globeToolbar/主视角.png",
                imgZoomIn: "globeToolbar/ZoomIn.png",
                imgZoomOut: "globeToolbar/ZoomOut.png",
                imgClear: "globeToolbar/清除测量.png",
                imgNorth: "globeToolbar/north.png",
                isNorthShow: false,
                isSelectorShow: false,     // 切图细分选项
                layerRadio: "Google影像地图",
                radios: [
                    { label: "天地图矢量地图", value: "tdtVec", isChecked: false },
                    { label: "天地图图像地图", value: "tdtImg", isChecked: false },
                    { label: "Google影像地图", value: "googleImg", isChecked: true },
                    { label: "Bing影像地图", value: "bingImg", isChecked: false }
                ],
                roadOn: true,
                demOn: false,
                isEnterMeasure: false,
                isMeasureBarShow: false,  // “测量”系列按钮的横条 —— 开关
                changeZoomHeight: [0, 48000000, 24000000, 12000000, 6000000, 3000000, 1500000, 750000, 375000, 187500, 93750, 46875, 23438, 11719, 5860, 2930, 1465, 733, 367],
            };
        },
        computed: {
            //指北针的旋转角度样式
            compassAngleStyle() {
                return "rotate(" + this.$store.state.compassAngleNum + "deg)";
            }
        },
        methods: {
            showMeasure() {
                this.isMeasureBarShow = !this.isMeasureBarShow;
                this.isSelectorShow = false;
                if (window.cesiumView.drawOperatorFlag !== "") {
                    window.cesiumView.drawOperatorFlag = "";
                }
            },
            measureArea() {
                window.cesiumView.drawOperatorFlag = "MeasureArea";
                this.$store.state.isMeasuring = true;
            },
            measureDis() {
                window.cesiumView.drawOperatorFlag = "MeasureDistance";
                this.$store.state.isMeasuring = true;
            },
            measureClear() {
                window.cesiumView.drawOperatorFlag = "";
                window.cesiumView.drawDataSource.entities.removeAll();
                window.cesiumView.curMeasureIds = [];
                window.cesiumView.drawPolylinePath = [];
                window.cesiumView.drawPolyline = undefined;
                window.cesiumView.drawPolygonPath = [];
                window.cesiumView.drawPolygon = undefined;
                window.cesiumView.tooltip.style.display = "none";
                this.$store.state.isMeasuring = false;
            },
            home() {
                let that = this;
                window.viewer.camera.flyTo({
                    destination: this.Cesium.Cartesian3.fromDegrees(116.46, 39.92, 20000000),
                    complete: function(){
                        that.$store.state.level = that.utils.getCameraLevel(
                            Math.ceil(window.viewer.camera.positionCartographic.height)
                        );
                    }
                })
            },
            showRoad() {
                let type = "";
                this.roadOn = !this.roadOn;
                this.imgRoad = this.roadOn? "globeToolbar/路网开关(开_默认).png": "globeToolbar/路网开关(关_默认).png";
                this.radios.forEach(item => {
                    if (item.isChecked) {
                        type = item.value;
                    }
                });
                if (type === "tdtVec") {
                    window.cesiumView.tdtBzVectorLayer.show = this.roadOn;
                    if (this.roadOn) {
                        window.viewer.imageryLayers.raiseToTop(window.cesiumView.tdtBzVectorLayer);
                    }
                } else {
                    window.cesiumView.tdtBzImageLayer.show = this.roadOn;
                    if (this.roadOn) {
                        window.viewer.imageryLayers.raiseToTop(window.cesiumView.tdtBzImageLayer);
                    }
                }
                window.viewer.scene.requestRender();
            },
            check(index, value) {
                this.radios.forEach(item => {
                    item.isChecked = false;
                });
                this.radios[index].isChecked = true;
                switch (value) {
                    case "googleImg":
                        window.cesiumView.googleImageLayer.show = true;
                        window.cesiumView.tdtVectorLayer.show = false;
                        window.cesiumView.tdtImageLayer.show = false;
                        window.cesiumView.bingImageLayer.show = false;
                        break;
                    case "tdtImg":
                        window.cesiumView.googleImageLayer.show = false;
                        window.cesiumView.tdtVectorLayer.show = false;
                        window.cesiumView.tdtImageLayer.show = true;
                        window.cesiumView.bingImageLayer.show = false;
                        break;
                    case "tdtVec":
                        window.cesiumView.googleImageLayer.show = false;
                        window.cesiumView.tdtVectorLayer.show = true;
                        window.cesiumView.tdtImageLayer.show = false;
                        window.cesiumView.bingImageLayer.show = false;
                        break;
                    case "bingImg":
                        window.cesiumView.googleImageLayer.show = false;
                        window.cesiumView.tdtVectorLayer.show = false;
                        window.cesiumView.tdtImageLayer.show = false;
                        window.cesiumView.bingImageLayer.show = true;
                        break;
                }
                window.viewer.scene.requestRender();
            },
            clickZoom(operationName) {
                let pos = new this.Cesium.Cartesian2(window.viewer.canvas.clientWidth/2, window.viewer.canvas.clientHeight/2);
                let midCartesian = window.viewer.camera.pickEllipsoid(pos, window.viewer.scene.globe.ellipsoid);
                let lat = this.Cesium.Math.toDegrees(this.Cesium.Cartographic.fromCartesian(midCartesian).latitude);
                let lng = this.Cesium.Math.toDegrees(this.Cesium.Cartographic.fromCartesian(midCartesian).longitude);
                let currZoomLevel = this.$store.state.level;
                if (operationName === "subtract" && currZoomLevel >= 3) {
                    this.locatePoi(lng, lat, this.changeZoomHeight[currZoomLevel-1], currZoomLevel-1);
                } else if (operationName === "add") {
                    this.locatePoi(lng, lat, this.changeZoomHeight[currZoomLevel+1], currZoomLevel+1);
                }
            },
            //相机相关
            locatePoi(lng, lat, height, level) {
                let that = this;
                window.viewer.camera.flyTo({
                    destination: that.Cesium.Cartesian3.fromDegrees(lng, lat, height),
                    duration: 1.5,
                    complete: function() {
                        that.$store.state.level = level;
                    }
                });
            },
            compassMouseDown() {
                //指北针
                document.addEventListener("mousemove", this.compassMouseMove);
                document.addEventListener("mouseup", this.compassMouseUp);
            },
            compassMouseMove(event) {
                // 计算鼠标相对于指北针中心的角度
                this.$store.state.compassAngleNum = this.getCompassAngle(event);
                window.viewer.camera.setView({
                    orientation: {
                        heading : -this.Cesium.Math.toRadians(this.$store.state.compassAngleNum),  //x轴
                        pitch : window.viewer.camera.pitch,      //y轴
                        roll : window.viewer.camera.roll         //z轴
                    }
                });
            },
            getCompassAngle(event) {
                let mouseX = event.clientX;
                let mouseY = event.clientY;
                let centerX = this.$refs.compass.getBoundingClientRect().left + this.$refs.compass.offsetWidth / 2;
                let centerY = this.$refs.compass.getBoundingClientRect().top + this.$refs.compass.offsetHeight / 2;

                let x = Math.abs(centerX - mouseX);
                let y = Math.abs(centerY - mouseY);
                let z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
                let cos = y / z;
                let radian = Math.acos(cos); //用反三角函数求弧度
                let angle = 180 / (Math.PI / radian); //将弧度转换成角度

                if (mouseX > centerX && mouseY > centerY) {
                    //鼠标在第四象限
                    angle = 180 - angle;
                } else if (mouseX === centerX && mouseY > centerY) {
                    //鼠标在y轴负方向上
                    angle = 180;
                } else if (mouseX > centerX && mouseY === centerY) {
                    //鼠标在x轴正方向上
                    angle = 90;
                } else if (mouseX < centerX && mouseY > centerY) {
                    //鼠标在第三象限
                    angle = 180 + angle;
                } else if (mouseX < centerX && mouseY === centerY) {
                    //鼠标在x轴负方向
                    angle = 270;
                } else if (mouseX < centerX && mouseY < centerY) {
                    //鼠标在第二象限
                    angle = 360 - angle;
                }

                return angle;
            },
            compassMouseUp() {
                document.removeEventListener("mousemove", this.compassMouseMove);
                document.removeEventListener("mouseup", this.compassMouseUp);
            },
            North() {
                let camera = window.viewer.camera;
                let destination = camera.position;
                let wheelPosition = this.$store.state.wheelPos;
                if (wheelPosition !== undefined) {
                    let cartographic = this.Cesium.Cartographic.fromCartesian(wheelPosition);
                    let height = this.Cesium.Cartographic.fromCartesian(destination).height;
                    destination = this.Cesium.Cartesian3.fromDegrees(cartographic.longitude * 180 / Math.PI, cartographic.latitude * 180 / Math.PI, height);
                }
                camera.flyTo({
                    destination: destination,
                    orientation: {
                        heading: 6.283185307179586,
                        pitch: -1.5707963267948966,
                        roll: 0
                    },
                });
            },
            captureGlobe(){
                window.viewer.scene.canvas.toBlob(function (blob) {
                    saveAs(blob, 'Explorer可视化截图.png')
                }, 'image/png', 1)
            }
        }
    };
</script>

<style scoped>
    .homeGlobeToolBar {
        position: absolute;
        bottom: 1.2rem;
        right: 0.5rem;
        width: 2rem;
    }
    .globeToolButton {
        width: 1.8rem;
        height: 2rem;
        margin: 0.1rem auto 0 auto;
        background-color: transparent;
        cursor: pointer;
    }
    .img_box {
        height: 1.8rem;
        width: 1.8rem;
    }
    .measureBar {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 2.3rem;
        bottom: 14.6rem;
    }
    .measureIn {
        margin-right: 0.04rem !important;
    }
    .globeZoomButton {
        position: relative;
        width: 100%;
        height: 6.2rem;
        margin-top: 0.04rem;
        cursor: pointer;
    }
    .globeToolButton-button {
        width: 1.8rem;
        height: 1.8rem;
        background: transparent;
        cursor: pointer;
    }
    .globeZoomButton-circle {
        position: relative;
        top: 0.1rem;
        left: -0.3rem;
        width: 2.5rem;
        height: 2.5rem;
        z-index: 0;
    }
    .globeZoomButton-circle-outer {
        position: absolute;
        top: -0.25rem;
        left: -0.35rem;
        width: 3.2rem;
        height: 3.2rem;
        border: 0.3rem solid #263237;
        border-radius: 50%;
        box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.5);
    }
    .globeZoomButton-circle-inter {
        position: absolute;
        top: 0.1rem;
        width: 100%;
        height: 100%;
        background: #263237;
        border-radius: 50%;
        overflow: hidden;
        text-align: center;
    }
    .flex-div-layes {
        position: absolute;
        right: 2.3rem;
        bottom: 5.5rem;
        background-color: #263237;
        color: #eaeaea;
        width: 6rem;
        height: 5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        border-radius: 0.05rem;
    }
    .globeZoomButton-circle-inter-zoom {
        margin-top: 0.25rem;
        line-height: 1rem;
        font-size: 12px;
        color: #979797;
    }
    .globeZoomButton-circle-inter-value {
        line-height: 1rem;
        font-size: 12px;
        color: #eaeaea;
    }
    /* 修改到这里了 */
    @keyframes buttonClickAnimation {
        from {
            width: 0;
            height: 0;
        }
        to {
            width: 100%;
            height: 100%;
        }
    }
    /*切换图层按钮*/
    .radio-box {
        margin: 0.05rem 0.1rem;
        font-size: 0.8rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .triangle{
        position: absolute;
        width: 0;height: 0;
        z-index: 5;
        border-left: 0.3rem solid transparent;
        border-right: 0.3rem solid transparent;
        border-bottom: 0.3rem solid red;
        left:calc(50% - 0.3rem);
        top:-0.4rem;
    }
    .horizontalLine{
        position:absolute;
        top:calc(50% - 0.1rem);
        width:0.3rem;
        height:0.3rem;
        background:#A8A8A8;
    }
    .verticalLine{
        position: absolute;
        left: calc(50% - 0.1rem);
        bottom: -0.3rem;
        width: 0.3rem;
        height: 0.3rem;
        background:#A8A8A8;
    }
    .img_div_style{
        position: relative;
        bottom: -0.2rem;
        background-color: #243338;
        width: 1.8rem;
        height: 2rem;
        margin: 0.1rem auto 0 auto;
        cursor: pointer;
    }
    .img_style{
        position: relative;
        top: 0.2rem;
        left: 0.2rem;
        height: 1.6rem;
        width: 1.4rem;
    }
</style>
